import React from 'react';

import CustomCheckbox, { CustomCheckboxProps } from '@app/components/Forms/CustomCheckbox/CustomCheckbox';

interface ValidCustomCheckboxProps extends CustomCheckboxProps {
	firstSending: boolean;
}

const ValidCustomCheckbox: React.FC<ValidCustomCheckboxProps> = ({
	firstSending,
	isChecked,
	setIsChecked,
	formikBag,
	capture,
}) => {
	return (
		<CustomCheckbox
			className={`valid-custom-checkbox ${firstSending ? isChecked ? '' : 'valid-custom-checkbox__error' : ''}`}
			isChecked={isChecked}
			setIsChecked={setIsChecked}
			formikBag={formikBag}
			capture={
				<div className="is-relative">
					{capture}
					{firstSending && !isChecked && <div className="validation-message">Please check the box to submit this form</div>}
				</div>
			}
		/>
	);
};

export default ValidCustomCheckbox;
